<template>
  <a-layout has-sider>
    <a-layout-sider
      v-model:collapsed="collapsed"
      :trigger="null"
      collapsible
      :collapsed-width="width > 1024 ? 64 : 44"
      width="280px"
      style="height: 100vh; position: sticky; top: 0; left: 0"
      :class="[
        'z-[1000] transition-all sm:block hidden',
        { 'slide-bar-out': !collapseSideBar && collapsed }
      ]"
      @mouseleave="handleCollapseSideBar(false)"
      @mouseenter="handleCollapseSideBar(true)"
    >
      <div :class="[`py-2 px-5 flex items-center justify-center h-[48px]`]">
        <router-link v-if="!collapsed" :to="{ path: '/' }">
          <img src="/logo_sider_bar_white.jpg" alt="" style="width: 75%; height: auto" />
        </router-link>
        <menu-unfold-outlined
          v-if="collapsed"
          class="trigger"
          style="color: white; font-size: 24px"
          @click="handleCollapseMenu"
        />
        <menu-fold-outlined
          v-else
          class="trigger"
          style="color: white; font-size: 24px"
          @click="handleCollapseMenu"
        />
      </div>
      <SiderMenu :menus="menus" :collapsed="collapsed" @toggle-collapse="toggleCollapse" />
    </a-layout-sider>
    <a-layout
      class="layout-main-content transition-all"
      :class="`layout-${nameRouter?.name?.replace(/[./]/g, '-')} `"
    >
      <global-header
        class="sm:flex hidden"
        :sidebar-opened="!collapsed"
        :sidebar-slide="collapseSideBar"
      />
      <mobile-header custom-class="sm:hidden block" :menus="menus" />
      <a-layout-content
        class="main-content"
        :class="`${hasFooter ? 'sm:my-12' : 'mt-12'} `"
        :style="{
          padding: '8px',
          backgroundColor:
            nameRouter?.name === RouterName.ANOMALY_MONITORING_ALERT_WARNING_STATISTICS
              ? '#0f172a'
              : '#f5f5f5',
          color:
            nameRouter?.name === RouterName.ANOMALY_MONITORING_ALERT_WARNING_STATISTICS
              ? '#c1c1c1'
              : null
        }"
      >
        <router-view />
      </a-layout-content>
      <global-footer />
    </a-layout>
  </a-layout>
  <modal-warning-change-password
    :visible="showModalChangePassword"
    @close-modal="closeModalWarningChangePassword"
  />
</template>

<script lang="ts" setup>
import { MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons-vue'
import { computed, onMounted, ref, watch } from 'vue'
import SiderMenu from '@/components/menu/SideMenu.vue'
import { useRoute, useRouter } from 'vue-router'
import GlobalHeader from '@/components/header/index.vue'
import GlobalFooter from '@/components/footer/index.vue'
import { getItemFromLocalStorage, setItemToLocalStorage } from '@/utils'
import { KEY_LOCAL } from '@/contants'
import { useAuthStore } from '@/stores/authStore.ts'
import ModalWarningChangePassword from '@/components/account/ModalChangePassword.vue'
import { RouterName } from '@/routes/config.ts'
import debounce from 'lodash/debounce.js'
import { useGlobalStore } from '@/stores/globalStore.ts'

const pageList = [
  RouterName.ANOMALY_MONITORING_ALERT_WARNING_STATISTICS,
  RouterName.ANOMALY_MONITORING_ALERT_DMX,
  RouterName.ANOMALY_MONITORING_ALERT_GENERAL
]

const width = window.screen.width
const nameRouter = useRoute()
const menus = ref([])
const collapsed = ref<boolean>(false)
const {
  auth: { showModalChangePassword }
} = useAuthStore()

const route = useRoute()
const globalStore = useGlobalStore()

const hasFooter = computed(() => {
  return !pageList.includes(route?.name)
})

onMounted(() => {
  const originRouter = useRouter()
  const routerMenu = originRouter.getRoutes().find((item) => item.path === '/')
  menus.value = (routerMenu && routerMenu.children) || []

  const collapseValue = getItemFromLocalStorage(`${KEY_LOCAL}collapsedSideMenu`)
  collapsed.value = typeof collapseValue === 'boolean' ? collapseValue : false
  globalStore.setMenu(collapsed.value)
})

const toggleCollapse = () => {
  if (!collapsed.value) {
    setItemToLocalStorage(`${KEY_LOCAL}collapsedSideMenu`, true)
    collapsed.value = true
    globalStore.setMenu(collapsed.value)
  }
}
const handleCollapseMenu = () => {
  collapsed.value = !collapsed.value
  setItemToLocalStorage(`${KEY_LOCAL}collapsedSideMenu`, collapsed.value)
  globalStore.setMenu(collapsed.value)
}

const closeModalWarningChangePassword = () => {
  const authStore = useAuthStore()
  authStore.setShowModalChangePassword(false)
}

const collapseSideBar = ref(true)

const handleCollapseSideBar = debounce((val) => {
  if (
    [
      RouterName.ANOMALY_MONITORING_ALERT_WARNING_STATISTICS,
      RouterName.ANOMALY_MONITORING_ALERT_DMX,
      RouterName.ANOMALY_MONITORING_ALERT_GENERAL
    ].includes(nameRouter.name)
  ) {
    collapseSideBar.value = val
  }
}, 300)

watch(
  nameRouter,
  () => {
    collapseSideBar.value = true
  },
  { immediate: true, deep: true }
)
</script>

<style scoped lang="scss">
.page-transition-enter {
  opacity: 0;
}

.page-transition-leave-active {
  opacity: 0;
}

.page-transition-enter .page-transition-container,
.page-transition-leave-active .page-transition-container {
  transform: scale(1.5);
}
.layout-main-content {
  display: flex;
  flex-direction: column;
}
.main-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.ant-layout-content {
  flex: unset !important;
}
.slide-bar-out {
  flex: 0 0 0 !important;
  max-width: 0 !important;
  min-width: 0 !important;
  width: 0 !important;
}
</style>
